module.exports = __webpack_public_path__ + "img/scenario_08.c544b969.jpg";